<div class="customer-list">
    <div class="header">
    <h2 class="title">Customers</h2>
    <div class="cards-row w-100">
        <div>
            <app-card
            [label]="'Total'"
            [value]="4553943"
            [showDropdown]="true"
            [showToggle]="false"
            (toggleDropdown)="handleDropdownChange($event)"
            >        
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'New Entry'"
        [value]="465"
        [showDropdown]="true"
        [showToggle]="false"
        (toggleDropdown)="handleDropdownChange($event)"
        >
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'Regularized'"
        [value]="143"
        [showDropdown]="true"
        [showToggle]="false"
        (toggleDropdown)="handleDropdownChange($event)"
        [dropdownItems]="[
            { label: 'Invalid Meter Number', value: 346 },
            { label: 'Alpha Meter Type', value: 1 },
            { label: 'Meter Number starts with 24', value: 8509 },
            { label: 'With Account Number', value: 45760 },
            { label: 'With SPN', value: 251674 },
        ]"
        >
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'Existing'"
        [value]="163657"
        [showDropdown]="false"
        [showToggle]="false">
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'Direct Connection'"
        [value]="15"
        [showDropdown]="false"
        [showToggle]="true"
        (toggleChanged)="handleToggleChange($event)">
        >
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'COMMON.ASSET_STATUS.RETAGGED'"
        [value]="8"
        [showDropdown]="false"
        [showToggle]="false">
        </app-card>
    </div>
    <div>
        <app-card
        [label]="'Unvalidated'"
        [value]="449625"
        [showDropdown]="false"
        [showToggle]="false">
        </app-card>
    </div>
  </div>
  <div class="row filter">
    <div class="col-7 filter-bar">
        <div class="dropdown">
            <button (click)="toggleDropdown()" class="dropdown-button">
                {{ searchByName }}
                <img src="../../../assets/icons/ng_v3/dropdown-icon.svg" alt="dropdown icon" />
            </button>
            <div *ngIf="dropdownOpened" class="dropdown-options">
                <div class="dropdown-description">Search Method</div>
               <div (click)="selectSearchtByOption(searchByOptions.ACC_NO)" class="dropdown-option">Account No.</div> 
               <div (click)="selectSearchtByOption(searchByOptions.SLRN)" class="dropdown-option">SLRN</div> 
               <div (click)="selectSearchtByOption(searchByOptions.METER_NO)" class="dropdown-option">Meter No.</div> 
               <div (click)="selectSearchtByOption(searchByOptions.BUILDING_OWNER)" class="dropdown-option">Building Owner</div> 
               <div (click)="selectSearchtByOption(searchByOptions.PHONE_NUMBER)" class="dropdown-option">Phone No.</div> 
               <div (click)="selectSearchtByOption(searchByOptions.EMAIL)" class="dropdown-option">Email</div> 
            </div>
        </div>
        <app-filter (sortChanged)="onSortChanged($event)"></app-filter>
    </div>
    <div class="col-5 text-end download-btn-wrapper">
        <button>Download</button>
    </div>
  </div>
  </div>
  <div class="table-wrapper">
  <div class="table-container">
    <table>
      <thead>
        <tr>
          <th class="th-checkbox"><input type="checkbox" /></th>
          <th>SLRN</th>
          <th>Building Owner</th>
          <th>Account Number</th>
          <th>Meter Number</th>
          <th>DS Name</th>
          <th>Tariff</th>
          <th>Validation Status</th>
          <th>Tag</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status assigned">Assigned</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status pending">Pending</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag existing">Existing</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag existing">Existing</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag existing">Existing</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
        <tr>
          <td><input type="checkbox" /></td>
          <td>ECGBD9009128</td>
          <td>MR ADJETEY GIDEON A</td>
          <td>701756039</td>
          <td>701756039</td>
          <td>TALABI TRANSFORMER</td>
          <td>Residential (prepayment)</td>
          <td><span class="status completed">Completed</span></td>
          <td><span class="tag new">New Entry</span></td>
          <td><span class="icon">⟳</span></td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination">
    <div class="pagination-info">Showing 1 to 10 of 34 entries</div>
    <div class="pagination-controls">
      <button disabled>&laquo;</button>
      <button disabled>&lt;</button>
      <button class="active">1</button>
      <button>2</button>
      <button>3</button>
      <button>4</button>
      <button>5</button>
      <button>&gt;</button>
      <button>&raquo;</button>
      <button>GO</button>
    </div>
  </div>
</div>

</div>